// This icon file is generated automatically.
var PDownSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M6.9 9.3c.05.06.15.06.2 0l2.78-3.85c.06-.08 0-.2-.1-.2h-.73a.5.5 0 00-.4.2L7 7.74 5.36 5.46a.5.5 0 00-.4-.21h-.74c-.1 0-.16.12-.1.2L6.9 9.29z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-down-square", "theme": "outlined" };
export default PDownSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDownSquareOutlined.js
// module id = 3349
// module chunks = 0